import { map, isArray, set, last, extend, isFunction } from 'lodash-es';
import { Openapi } from './openapi';
import { Application } from '../application';

type DataSourceAccessor = () => Promise<any>;
type DataSource = (params?: Function | Dictionary<any>) => Promise<any>;

export function createSlickDataSource(
  app: Application,
  options: SlickDataSourceOptions,
) {
  const ds = datasourceFromString(app, options.name);

  return async function () {
    const r = await ds(options.parameters);
    if (r) {
      return onResultData(r, options);
    }
  };
}

export interface SlickDataSourceOptions {
  name: string;
  parameters?: Dictionary<any> | Function;
  assignUniqueId?: boolean;
}

function onResultData(data: any, options: SlickDataSourceOptions) {
  if (options.assignUniqueId && isArray(data)) {
    return map(data, (p, i) => {
      if (p && typeof p === 'object' && p.id != null && p.originalId == null) {
        p.originalId = p.id;
      }
      return set(p, 'id', i);
    });
  }
  return data;
}

function datasourceFromString(app: Application, dataSource: string) {
  const openapi = app.connections.getConnection('default') as Openapi;
  const operationId = last(dataSource.split('/'))!;

  return async function (params?: Function | Dictionary<any>) {
    const result = await openapi.request(operationId, {
      parameters: extend({ skip: 0 }, resolveParams(params)),
    });
    return isArray(result.data) ? result.data : result.data['data'];
  };
}

function resolveParams(params?: Function | Dictionary<any>) {
  if (isFunction(params)) {
    return params();
  }
  return params;
}
